import { render } from "./ZambiaTerms.vue?vue&type=template&id=47e8b3ed&scoped=true"
import script from "./ZambiaTerms.vue?vue&type=script&lang=js"
export * from "./ZambiaTerms.vue?vue&type=script&lang=js"

import "./ZambiaTerms.vue?vue&type=style&index=0&id=47e8b3ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e8b3ed"]])

export default __exports__